import HekateFormElementDefinition from './HekateFormElementDefinition';
import HekateOptionList from './HekateOptionList';
export default class HekateFormDefinition {
    constructor({ id, name, updatedBy, updatedAt, htmlName, elements, folderId, }) {
        this.id = id;
        this.name = name;
        this.updatedBy = updatedBy;
        this.updatedAt = updatedAt;
        this.htmlName = htmlName;
        this.elements = elements;
        this.folderId = folderId;
    }
    /** Add the element to elements if the element is not in elements (before the submit button) */
    static addElementIfDoesNotExists(element, elements) {
        const elementFoundIndex = elements.findIndex((cur) => cur.htmlName === element.htmlName);
        if (elementFoundIndex !== -1) {
            return;
        }
        let submitIndex = elements.findIndex((elm) => elm.displayType === 'submit');
        if (submitIndex === -1) {
            submitIndex = elements.length - 1;
        }
        elements.splice(submitIndex, 0, element);
    }
    /** Create a form from a form blob as the json blob comes back from eloqua or firebase/hekate */
    static fromBlob(formBlob) {
        var _a;
        const id = formBlob.id;
        const name = formBlob.name;
        const updatedBy = formBlob.updatedBy;
        const updatedAt = formBlob.updatedAt;
        const htmlName = formBlob.htmlName;
        const folderId = (_a = formBlob.folderId) !== null && _a !== void 0 ? _a : '';
        const elements = formBlob.elements.map((elmBlob) => HekateFormElementDefinition.fromBlob(elmBlob));
        HekateFormDefinition.addElementIfDoesNotExists(new HekateFormElementDefinition({
            id: '2188',
            dataType: 'string',
            displayType: 'text',
            displayVariantType: '',
            htmlName: 'elqCustomerGUID',
            name: 'Eloqua Customer GUID',
            optionList: HekateOptionList.newEmptyList(),
            optionListId: '',
            validations: [],
        }), elements);
        HekateFormDefinition.addElementIfDoesNotExists(new HekateFormElementDefinition({
            id: '-2',
            dataType: 'string',
            displayType: 'recaptcha',
            displayVariantType: '',
            htmlName: 'hekateRecaptcha',
            name: 'Hekate Recaptcha',
            optionList: HekateOptionList.newEmptyList(),
            optionListId: '',
            validations: [],
        }), elements);
        return new HekateFormDefinition({
            id,
            name,
            updatedBy,
            updatedAt,
            htmlName,
            elements,
            folderId,
        });
    }
    /** Logically compare (suitable for serialization check) */
    compareTo(rhs) {
        return (this.id === rhs.id &&
            this.folderId === rhs.folderId &&
            this.name === rhs.name &&
            this.updatedAt === rhs.updatedAt &&
            this.updatedBy === rhs.updatedBy &&
            this.htmlName === rhs.htmlName &&
            this.elements.length === rhs.elements.length &&
            !this.elements.find((lhs, ii) => !lhs.compareTo(rhs.elements[ii])));
    }
}
